import { combineReducers } from 'redux';
import * as ShareableLinkActionTypes from '../../types/shareableLink';

const reducer = combineReducers({
    link,
    isLoading
});

function link(state = null, action = {}) {
    switch (action.type) {
        case ShareableLinkActionTypes.FETCH_SUCCESS: {
            return action.link;
        }

        case ShareableLinkActionTypes.SET_SHAREABLE_LINK: {
            return action.link;
        }

        case ShareableLinkActionTypes.SET_STATUS: {
            if (!state) {
                return state;
            }

            return {
                ...state,
                status: action.status
            };
        }

        default: {
            return state;
        }
    }
}

function isLoading(state = false, action = {}) {
    switch (action.type) {
        case ShareableLinkActionTypes.FETCH_START:
            return true;
        case ShareableLinkActionTypes.FETCH_SUCCESS:
        case ShareableLinkActionTypes.SET_SHAREABLE_LINK:
        case ShareableLinkActionTypes.FETCH_FAILURE:
            return false;
        default:
            return state;
    }
}

export default reducer;
